import EfScrollAni from '@/efscrollani';
import { useProductStore } from 'elem/compPage/how-to-choose/ProductProvider';
import { IPageStatus } from '@elem/compPage/how-to-choose/config/IPageStatus';
import StatusA from './StatusA';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return <div className="page-product">{pageStatus === IPageStatus.statusA && <StatusA />}</div>;
}
